<template>
	<div class="drawer-item-wrapper">
		<div
			class="drawer-item surf-transition-drawer-item"
			:class="{
				'has-children': hasDropdownContent,
				active: isMenuActive
			}"
			@click="handleItemClick"
		>
			<span class="drawer-item-name text-overflow">{{ menu.name }}</span>
			<SvgIcons
				v-if="hasDropdownContent"
				name="down"
				class="drawer-item-arrow"
				:class="{ expanded: expanded }"
				@click.stop="handleToggleExpand"
			/>
		</div>

		<!-- 下拉内容：子菜单和模块 -->
		<div v-if="hasDropdownContent && expanded" class="drawer-content">
			<!-- 子菜单 -->
			<template v-if="hasSubMenus">
				<DrawerMenuItem
					v-for="subMenu in menu.pageMenuVOS"
					:key="subMenu.uuid"
					:menu="subMenu"
					@click="$emit('click', $event)"
				/>
			</template>

			<!-- 模块列表 -->
			<template v-if="hasModules">
				<template v-for="module in menu.moduleVOS">
					<div
						v-if="enableShowModule(module)"
						:key="module.moduleId"
						class="drawer-module-item surf-transition-drawer-item text-overflow"
						:class="{ active: isModuleActive(module) }"
						@click.stop="handleModuleClick(module)"
					>
						{{ module.name }}
					</div>
				</template>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SurfDrawerMenuItem'
};
</script>
<script setup>
import DrawerMenuItem from './DrawerMenuItem.vue';
import { computed } from 'vue';
import SvgIcons from '@/components/SvgIcons.vue';
import { useDrawerMenuItem } from './useDrawerMenuItem';
import { resolveDefaultMenu } from './useNavMenu';

const props = defineProps({
	menu: {
		type: Object,
		required: true
	}
});
const currentMenu = computed(() => props.menu);
const emit = defineEmits(['click']);

const {
	hasSubMenus,
	hasModules,
	hasDropdownContent,
	enableShowModule,
	isModuleActive,
	isMenuActive,
	expanded,
	handleToggleExpand
} = useDrawerMenuItem(currentMenu);

const handleItemClick = () => {
	const defaultMenu = resolveDefaultMenu(currentMenu.value);
	emit('click', { menu: defaultMenu });
};
const handleModuleClick = module => {
	emit('click', { menu: currentMenu.value, module });
};
</script>

<style lang="less" scoped>
.drawer-item-wrapper {
	.drawer-item {
		display: flex;
		align-items: center;
		gap: 6px;
		cursor: pointer;

		&:hover,
		&.active {
			color: var(--surf-inverse-color);
		}
		&.active {
			font-weight: 500;
		}

		.drawer-item-arrow {
			flex-shrink: 0;
			font-size: 18px;
			color: var(--surf-inverse-color) !important;
			transition: transform 0.3s ease;
			cursor: pointer;

			&.expanded {
				transform: rotate(180deg);
			}
		}
	}

	.drawer-module-item {
		cursor: pointer;

		&:hover,
		&.active {
			color: var(--surf-inverse-color);
		}
	}
}

.surf-transition-drawer-item {
	transition: all 0.3s ease;
}

.drawer-item-wrapper {
	overflow: hidden; /* 配合文本内容溢出 */
	display: flex;
	flex-direction: column;
	gap: 40px;
}
.drawer-content {
	display: flex;
	flex-direction: column;
	gap: 32px;
}
.drawer-content {
	.drawer-item-wrapper {
		gap: 32px;
	}
	.drawer-content {
		padding-left: 12px;
	}
}

.drawer-item {
	font-size: 16px;
	color: rgba(var(--surf-inverse-color-rgb), 0.6);
}
.drawer-content,
.drawer-content .drawer-item {
	font-size: 14px;
	color: rgba(var(--surf-inverse-color-rgb), 0.3);
}
</style>
